import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#0b6b68", dark: "#074c4a", light: "#d4efec" },
    secondary: { main: "#ef7b59" },
    background: { default: "#f4f7f8", paper: "#ffffff" },
    text: { primary: "#17242b", secondary: "#607078" },
    success: { main: "#218c62" },
    warning: { main: "#d58b16" },
    error: { main: "#c94747" },
  },
  typography: {
    fontFamily: 'Inter, "Segoe UI", system-ui, sans-serif',
    h4: { fontWeight: 800, letterSpacing: "-0.035em" },
    h5: { fontWeight: 750, letterSpacing: "-0.025em" },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, textTransform: "none" },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #e5ecee",
          boxShadow: "0 8px 30px rgba(23,36,43,.05)",
        },
      },
    },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, color: "#53636b", background: "#f8fafb" },
      },
    },
  },
});
